<template>
    <div class="typography">
        <div class="row indentation">
            <div class="col header text-left">
                <h1>
                    Unkonventionelle, innovative Realisierung von Bauprojekten
                </h1>
            </div>
            <div class="col jubilee-wrapper">
                <img
                    src="../assets/images/logo/jubilee_emblem_ic_2024.png"
                    class="jubilee"
                    alt="Jubiläumsemblem"
                    height="60"
                    align="right"
                />
            </div>
        </div>

        <hr />
        <div class="row indentation section">
            <div class="col-lg-4">
                <h4 class="title">Generalplanung</h4>
            </div>
            <h4 class="col-lg-8 details-text">
                <p class="details-title">Entwickelt. Plant. Realisiert.</p>
                <p>
                    Die Immocoach AG entwickelt, plant und realisiert
                    Industrie-, Logistik- und im speziellen Bauten für
                    Recyclingbetriebe. Sie ist bestens vertraut mit
                    Grossprojekten, die einer Umweltverträglichkeitsprüfung
                    unterstehen.
                </p>
                <p>
                    Immocoach übernimmt Projekte vorzugsweise als Generalplaner.
                    Angefangen bei der Grundstücksuche, einschliesslich
                    Architektur, bis hin zur schlüsselfertigen Übergabe.
                </p>
                <p>
                    Immocoach organisiert und koordiniert im Besonderen Anlagen
                    und dazugehörige Infrastrukturbauten in Zusammenarbeit mit
                    dem Bauherrn. Somit werden Planungsabläufe durch
                    Kompetenzabgrenzungen oder unklare Schnittstellen nicht
                    unnötig verlängert.
                </p>
            </h4>
        </div>

        <hr />
        <div class="row indentation section">
            <div class="col-lg-4">
                <h4 class="title">Beschaffungsmanagement</h4>
            </div>
            <h4 class="col-lg-8 details-text">
                <p class="details-title">Kauft direkt ein</p>
                <p>
                    Immocoach managt die Beschaffung von grösseren
                    Baukomponenten - wenn immer möglich direkt. Weil sie direkt
                    einkauft, ist eine einwandfreie Qualität garantiert und
                    Zwischenmargen fallen weg, zum Kostenvorteil des Bauherrn.
                </p>
            </h4>
        </div>

        <hr />
        <div class="row indentation section">
            <div class="col-lg-4">
                <h4 class="title">Vorteile</h4>
            </div>
            <h4 class="col-lg-8 details-text">
                <ul class="pros-list details-title">
                    <li>1 Ansprechpartner</li>
                    <li>
                        gemeinsame Auswahl der zu beauftragenden Unternehmungen
                    </li>
                    <li>gemeinsame Auftragsvergabe</li>
                    <li>gemeinsame Umsetzung</li>
                </ul>
                <p>
                    <i
                        >«Unser Vorgehen ist individuell auf das jeweilige
                        Bauprojekt zugeschnitten. In Zusammenarbeit mit uns
                        ergibt sich eine klassische Win-win-Situation: Wir
                        durchbrechen alteingefahrene Abläufe und Strukturen und
                        erzielen so Gewinne – in zeitlicher und finanzieller
                        Hinsicht.»</i
                    >
                </p>
                <p>Beat Hagmann, Geschäftsführer von Immocoach</p>
            </h4>
        </div>

        <hr />
        <div class="row indentation section">
            <div class="col-lg-4">
                <h4 class="title">Get in touch</h4>
            </div>
            <h4 class="col-lg-8 details-text">
                <img :src="pictureUrl" alt="Beat Hagmann" />
                <a
                    href="mailto:beat.hagmann@immocoach.ch"
                    target="_top"
                    class="email"
                    >Email an Beat Hagmann</a
                >
            </h4>
        </div>

        <immo-footer />
    </div>
</template>

<script>
import ImmoFooter from './Footer.vue'

export default {
    name: 'about',
    components: {
        ImmoFooter
    },
    props: {
        config: ''
    },
    computed: {
        pictureUrl: function() {
            return require('../assets/images/about/hagmann.jpg')
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../styles/main.scss';

.gallery-padding {
    padding-left: 15px;
    padding-right: 15px;
}

.gallery-item {
    padding: 0;
}

.header {
    font-family: 'miso-light', Arial, sans-serif;
    padding-top: 110px;
    padding-bottom: 80px;
    padding-left: 1rem;
}

.title {
    font-family: 'miso-bold', Arial, sans-serif;
    text-align: left;
    color: $immocoach-blue;
    text-transform: uppercase;
}

.indentation {
    padding-left: $main-indent;
    padding-right: $main-indent;
}

.section {
    padding-top: 56px;
    padding-bottom: 56px;
}

.gap {
    padding: 10px;
}

.details-title {
    font-family: 'miso-bold', Arial, sans-serif;
}

.details-text {
    text-align: left;
    font-family: 'miso-light', Arial, sans-serif;
}

.pros-list {
    padding-left: 0;
}
.pros-list li {
    list-style-position: inside;
}

.picture,
.email {
    vertical-align: 0;
    display: inline-block;
}

.email {
    color: black;
    vertical-align: top;
    margin-left: 30px;
}

.jubilee-wrapper {
    padding-top: 95px;
    padding-bottom: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/AboutComponent.vue